export const environment = {
  production: true,
  api: 'https://uat.sso-api.logistics.rtp-eservice.com',
  appVersion: "pmn",
  USERDATA_KEY: "9a5f56ffc495",
  portal: 'https://uat.lpms.logistics.rtp-eservice.com',
  sso: 'https://uat.sso.logistics.rtp-eservice.com',
};
